<div class="maintenance ui-g-12 p-0">
  <!-- Maintenance filter -->
  <div class="maintenance-filter ui-g-12 pr-2 pl-2 pt-3 pb-3 mb-2">
    <div class="ui-g-7 p-0">
      <div class="switch-style-secondary">
        <app-switch-button id="maintenance-filter-switch" valueField="value" paddingClass="p-1" [fontSize]="14"
          [showselectedCircle]="false" [value]="activeMaintenanceBy" [showIcons]="true" [options]="maintenance"
          (appChange)="handleMaintenanceByChange($event)">
        </app-switch-button>
      </div>
    </div>

    <div class="ui-g-5 p-0">
      <div class="flex-end-center">
        <span class="pr-2">{{activeMaintenanceBy.label}}: </span>
        <app-dropdown *ngIf="activeMaintenanceBy.value !== 'mileage'" class="interval-dropdown" theme="border"
          field="label" scrollHeight="300px" [autoFocus]="activeMaintenanceBy.value !== 'mileage'"
          [isLoading]="intervalLoading" [fontSize]="14" [listItemFontSize]="14" [value]="selectedInterval"
          [options]="intervals" [placeholder]="activeMaintenanceBy.placeholder" (appSelect)="handleSelect($event)">
        </app-dropdown>

        <div *ngIf="activeMaintenanceBy.value === 'mileage'" class="flex-start-center mileage-fields">
          <app-input theme="border" placeholder="Mileage" mask="99999999" [autoFocus]="true" [value]="mileage.value"
            (appChange)="mileage.value = $event" (appBlur)="handleMileageChange()"></app-input>

          <app-dropdown theme="border" field="label" placeholder="" [fontSize]="14" [listItemFontSize]="14"
            [value]="mileage.unit" [options]="mileageUnits"
            (appSelect)="mileage.unit = $event; handleMaintenanceByChange(activeMaintenanceBy)">
          </app-dropdown>
        </div>
      </div>
    </div>
  </div>

  <!-- Maintenance body -->
  <div class="ui-g-12 p-0 motor-service">
    <div *ngIf="motorVehicleId" class="ui-g-12 p-0 canned-service-browse-content">
      <div class="ui-g-12 p-0 motor-service-wrapper">
        <div class="flex-column">
          <!-- Motor service header -->
          <div class="motor-service-header flex-start-center">
            <p class="m-0 font-bold name">Operational</p>
            <p class="m-0 font-bold labor">Labor</p>
            <p class="m-0 font-bold part">Parts</p>
            <p class="m-0 font-bold fluid">Fluids</p>
            <p class="m-0 font-bold subtotal">Subtotal</p>
            <p *ngIf="!isServiceLookup" class="m-0 font-bold estimate">Add to Estimate</p>
          </div>

          <div class="motor-service-item-wrapper width-100p flex-column">
            <div class="flex-center-center motor-app-loading" [hidden]="!isMotorServiceLoading">
              <span class="pr-2">Loading</span>
              <i class="fal fa-spinner rotate"></i>
            </div>

            <div class="flex-center-center motor-app-loading"
              *ngIf="!isMotorServiceLoading && activeMaintenanceBy?.value === 'mileage' && !mileage?.value">
              <span class="pr-2">Please enter mileage to view mileage based services.</span>
            </div>

            <div *ngIf="!isMotorServiceLoading && applications?.length && !query"
              class="maintenance-schedule-header width pt-1 pb-1 pr-3 pl-3">
              <p class="m-0" [hidden]="activeMaintenanceBy?.value === 'mileage'">
                <span class="capitalize">{{selectedInterval?.label}} schedule</span>
              </p>

              <p class="m-0" [hidden]="activeMaintenanceBy?.value !== 'mileage'">
                {{selectedInterval?.value || 0 | number: '1.0-0'}} {{mileage?.unit?.value === 'km'? 'KM' : 'Miles'}}
                schedule
              </p>
            </div>

            <div *ngFor="let application of applications; let applicationIndex = index"
              class="motor-service-item flex-column flex-center-start" listItemLabel="title"
              [hidden]="isMotorServiceLoading || (activeMaintenanceBy?.value === 'mileage' && !mileage?.value)">
              <app-accordian listItemKey="items" listItemLabel="" [confirmationTitle]="confirmationTitle"
                [confirmationContent]="confirmationContent" listItemIdKey="itemSourceId" dataIdKey="SApplicationID"
                [showConfirmDeselectModal]="true" [data]="application" [hasItemCheckbox]="true" [iconSize]="10"
                [fontSize]="12" [index]="applicationIndex" [hasCustomHeader]="true" [hasAccordianSubItem]="true"
                [hasAccordianSubItemCheckbox]="true" [hasQuantityChanged]="hasQuantityChanged" [hasLaborSelected]="true"
                (handleItemSelectChange)="handleSelectChangeMotor($event, application)"
                (handleReset)="handleReset($event)">
                <ng-template appTemplate="accordian-header" let-selectAll="selectAll">
                  <div class="flex-start-center motor-service-acc-header"
                    (click)="addToEstmateMotor(application, selectedMotorServices[application.SApplicationID]?.extra?.isAdded, selectAll, $event, true, applicationIndex)">
                    <div class="flex-column flex-start-start name">
                      <span class="motor-service-name text-truncate font-13 font-600"
                        [pTooltip]="application?.DisplayName">
                        {{application?.DisplayName}}
                      </span>

                      <span class="motor-service-name text-truncate font-12" [pTooltip]="application?.subheading">
                        {{application?.subheading}}
                      </span>
                    </div>

                    <div class="flex-center-start font-12 m-width-65 flex-column mr-1 labor">
                      <span>
                        {{ application?.serviceTotal?.labor || 0 | currency: usd }}
                      </span>

                      <span class="flex-center-center">
                        <i class="far fa-clock fa-icon-light-gray pr-2"></i>
                        {{application?.count?.labor || 0 | number : '1.2-2' }}
                      </span>
                    </div>

                    <!-- Part -->
                    <div class="flex-center-start font-12 m-width-65 flex-column part">
                      <span>
                        {{ application?.serviceTotal?.parts || 0 | currency: usd }}
                      </span>

                      <span class="flex-center-center">
                        <i class="far fa-tools fa-icon-light-gray pr-2"></i>
                        {{application?.count?.parts || 0 | number : '1.2-2'}}
                      </span>
                    </div>

                    <!-- Tire -->
                    <div class="flex-center-start font-12 m-width-65 flex-column fluid">
                      <span>
                        {{ application?.serviceTotal?.fluids || 0 | currency: usd }}
                      </span>

                      <span class="flex-center-center">
                        <i class="far fa-list-alt fa-icon-light-gray pr-2"></i>
                        {{application?.count?.fluids || 0 | number : '1.2-2'}}
                      </span>
                    </div>

                    <div class="flex-center-start font-12 m-width-65 flex-column subtotal">
                      <span>
                        {{ application?.serviceTotal?.total || 0 | currency: usd }}
                      </span>

                      <span class="flex-center-center invisible">
                        <i class="far fa-ballot-check fa-icon-light-gray pr-2"></i>
                        {{application?.inspection != undefined ? 1 : 0}}
                      </span>
                    </div>

                    <div *ngIf="selectedMotorServices[application.SApplicationID] && !isServiceLookup"
                      id="'btn-selected-est{{applicationIndex}}"
                      class="font-11 pointer add-est-btn btn-gray text-center estimate">
                      Selected
                    </div>

                    <div *ngIf="!selectedMotorServices[application.SApplicationID] && !isServiceLookup"
                      id="btn-add-est{{applicationIndex}}"
                      class="font-11 pointer add-est-btn btn-white text-center estimate">
                      Add
                    </div>
                  </div>
                </ng-template>

                <ng-template let-item let-checkboxId="checkboxId" appTemplate="accordian-sub-item">
                  <label class="flex-between-center width-100p mb-0 pointer" [for]="checkboxId">
                    <div class="flex-start-start font-12">
                      <p class="m-0 flex-column">
                        <span class="pl-2 text-truncate width-480px" [pTooltip]="item.title">{{item.title}}</span>
                        <span class="pl-2 text-truncate width-480px"
                          [pTooltip]="item.subheading">{{item.subheading}}</span>
                      </p>
                    </div>

                    <div class="motor-line-item-total flex-between-center">
                      <!-- Default hours -->
                      <div class="default-hours flex-column">
                        <div class="flex-start-center font-11 font-secondary-800 position-relative">
                          <i *ngIf="item.type === 'labor'" class="far fa-clock font-gray-45 pr-1"></i>
                          <i *ngIf="item.type === 'fluids'" class="far fa-list-alt font-gray-45 pr-1"></i>
                          <i *ngIf="item.type === 'parts'" class="far fa-tools font-gray-45 pr-1"></i>

                          <span class="motor-m" *ngIf="item.type === 'labor'"></span>
                          {{ item.actualLaborTime }}
                        </div>
                        <div class="flex-start-center font-9 font-gray-35 motor-duration">
                          MOTOR {{ item.type === 'fluids' ? units.fluids[item.unitOfMeasuring] : units[item.type] }}
                        </div>
                      </div>

                      <div class="mr-2">
                        <div class="flex-start-center position-relative hours-input">
                          <app-input class="width-80px" placeholder="0" theme="border" styleClassInput="pl-0"
                            styleClass="pl-2 bg-color-white" [fontSize]="12"
                            [allowDecimal]="(focus[application.SApplicationID + '' +  item.itemSourceId])? true : false"
                            [selectTextOnFocus]="true" [disabled]="!selectedMotorServices[application.SApplicationID]"
                            [value]="(focus[application.SApplicationID + ''  + item.itemSourceId])? item.count : item.count | number : '1.2-2'"
                            (appClickInput)="handleInputClick(item, !selectedMotorServices[application.SApplicationID])"
                            (appFocus)="handleFocus(application.SApplicationID + ''  + item.itemSourceId, !selectedMotorServices[application.SApplicationID])"
                            (appBlur)="handleBlur(application.SApplicationID, item.itemSourceId, applicationIndex)"
                            (appKeyUp)="handleChange(application.SApplicationID , item.itemSourceId, $event)">
                          </app-input>

                          <i *ngIf="item?.type === 'labor' && (numberObj(application?.defaultItemCount[item.itemSourceId]) !== numberObj(application?.itemCount[item.itemSourceId]))"
                            class="fal fa-undo undo-marked-up pointer"
                            [pTooltip]="showTooltip(item.actualLaborTime, item.motorMarkup, application?.defaultItemCount[item.itemSourceId])"
                            (click)="handleRevertManualHour(application.SApplicationID, item.itemSourceId, numberObj(application?.defaultItemCount[item.itemSourceId]), applicationIndex, $event)"></i>

                          <div class="text-wrapper-motor">
                            <span class="hrs">
                              {{ item.type === 'fluids' ? units.fluids[item.unitOfMeasuring] : units[item.type] }}
                            </span>

                            <span *ngIf="item?.type === 'labor'" class="hrs-text text-truncate"
                              style="max-width: 75px;">
                              {{ (numberObj(application?.defaultItemCount[item.itemSourceId]) ===
                              numberObj(application?.itemCount[item.itemSourceId])) ? 'Marked up' : 'Manually entered'
                              }}
                            </span>

                            <span *ngIf="item?.type !== 'labor'" class="hrs-text text-truncate"
                              style="max-width: 75px;">
                              MOTOR qty
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="flex-column mr-2  width-55px">
                        <div class="font-12 text-right font-600 font-gray">
                          {{ item.subTotal | currency: usd }}
                        </div>
                        <div class="font-9 text-right font-gray">{{item.quantity}}</div>
                      </div>
                    </div>
                  </label>
                </ng-template>
              </app-accordian>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!motorVehicleId" class="ui-g-12 p-0">
      <div class="flex-center-center motor-unlink-canned-service flex-column">
        <img src="../../../../assets/img/motor-unlink-icon.svg" alt="">
        <div class="pr-2 font-12 pt-2 font-gray-35" *ngIf="!isServiceLookup">
          Connect vehicle with MOTOR to view items
        </div>
        <div class="pr-2 font-12 pt-2 font-gray-35" *ngIf="isServiceLookup">Search vehicle to view services</div>
      </div>
    </div>
  </div>
</div>
